export default "__VITE_ASSET__5af1fb15__"